export class KeyValuesViewModel {
    key: any;
    values: object[];
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_crm_angular/src/app/view-model/keyValues.viewModel.ts